import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from 'src/app/services/breadcrumb.service';
import { IBreadCrumb } from 'src/app/data-models/Ibreadcrumb.interface';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {

  constructor(
    private breadCrumbsService : BreadcrumbsService
  ) { }

  ngOnInit() {
    this.updateBreadCrumbs();
  }

  updateBreadCrumbs()
  {
    let newBreadCrumbs : Array<IBreadCrumb> = new Array();

    newBreadCrumbs.push({
      label: "Blog",
      path: "/blog",
      active: true
    })

    this.breadCrumbsService.breadcrumbs.next(newBreadCrumbs);
  }

}
